import { ref } from "vue";

export const searchRegex = ref<RegExp>(new RegExp(`.*.*`, 'i'))
export function onInputSearch(event: any){
    searchRegex.value = new RegExp(`.*${event.target.value}.*`, 'i')
    return event;
}